const FETCH_CASE_NO_CONSENTS = 'fetch_caseNoConsents';
const FETCH_CASE_NO_CONSENTS_CSV = 'fetch_caseNoConsents_csv';
const FETCH_CASE_NO_CONSENT = 'fetch_caseNoConsent';
const DELETE_CASE_NO_CONSENT = 'delete_caseNoConsent';
const PERSIST_CASE_NO_CONSENT = 'persist_caseNoConsent';
export default {
    FETCH_CASE_NO_CONSENTS,
    FETCH_CASE_NO_CONSENTS_CSV,
    FETCH_CASE_NO_CONSENT,
    DELETE_CASE_NO_CONSENT,
    PERSIST_CASE_NO_CONSENT,
};
